import { MaxmindResponse } from 'embed/constants/maxmind'
import { buildUrl } from 'embed/utils'

export const isMaxmindResponse = (arg: MaxmindResponse): arg is MaxmindResponse =>
  arg !== undefined &&
  arg.city !== undefined &&
  arg.city.names !== undefined &&
  arg.postal !== undefined &&
  arg.postal.code !== undefined &&
  arg.subdivisions !== undefined &&
  arg.subdivisions[0] !== undefined

export class MaxMindGeolocator {
  public getGeoFromIP(): Promise<MaxmindResponse> {
    return new Promise<MaxmindResponse>((resolve, reject) => {
      const url = buildUrl('https://geoip-js.com/geoip/v2.1/city/me', {
        referrer: `${location.protocol}//${location.hostname}`,
      })
      return fetch(url.href, {
        method: 'GET',
      })
        .then(async (response) => {
          const status = response.status
          const data = await response.json()
          if (status === 200 && isMaxmindResponse(data)) {
            resolve(data)
          } else {
            reject(data)
          }
        })
        .catch((rejected) => {
          reject(rejected)
        })
    })
  }
}

export default new MaxMindGeolocator()
